
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import logo from '../../assets/new images/logo.png';
import sparkle  from '../../assets/new images/mentor btn.png';
import mentor from '../../assets/new images/coach btn.png';
import { Link } from "react-router-dom";
import { PLAY_STORE_URL } from "../../utils/structuredData";
import { track } from "../../utils/analytics";
const DARK = "#1E2A44";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="w-full text-white">
      {/* UPPER GRADIENT BANNER — exact look, no curve */}
      <section
        className="relative text-center pt-20 pb-16 px-4 overflow-hidden"
        style={{
          background:
            "linear-gradient(160deg, #EE5F2B 0%, #C1523E 35%, #3B4B69 90%, #1E2A44 100%)",
        }}
      >
        <div className="absolute inset-0 pointer-events-none">
          {/* top-left wide glow */}
          <div
            className="absolute left-[4%] top-[8%] w-[260px] h-[200px] rounded-full blur-[70px] opacity-40"
            style={{ background: "rgba(240, 229, 216, 0.85)" }}
          />
          {/* top-right compact glow */}
          <div
            className="absolute right-[6%] bottom-[8%] w-[260px] h-[200px] rounded-full blur-[55px] opacity-35"
            style={{ background: "rgba(240, 229, 216,0.9)" }}
          />
          {/* center-bottom band glow */}
          <div
            className="absolute inset-x-0 bottom-[18%] h-[100px] blur-[60px] opacity-20"
            style={{
              background:
                "radial-gradient(100% 100% at 50% 0%, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0) 65%)",
            }}
          />
        </div>

        <div className="relative z-10 max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight">
            {t("footer.cta")}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-white/90 max-w-2xl mx-auto">
            {t("footer.ctaSub")}
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4 ">
            <button className="group flex items-center gap-2 bg-white text-slate-800 px-6 py-3 rounded-xl font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 shadow-[0_0_10px_rgba(255,255,255,0.3)] hover:shadow-[0_0_20px_rgba(255,255,255,0.6)]">
            <img src={mentor} className="" alt="" />
            <Link to='/login/mentee-sign-up'>
              {t("footer.findMentor")}
              </Link>
              <svg width="16" height="16" viewBox="0 0 24 24" className="-mr-0.5 transition-transform duration-300 group-hover:translate-x-1">
                <path d="M13 5l7 7-7 7M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" />
              </svg>
            </button>
            <button className=" group flex items-center gap-2 border border-white/70 text-white px-6 py-3 rounded-xl font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 hover:shadow-[0_0_20px_rgba(255,255,255,0.6)] bg-white/10 backdrop-blur hover:bg-white/15">
             <img src={sparkle} className="" alt="" />
              <Link to='/login/mentee-sign-up'>
              {t("footer.tryAi")}</Link>
              <svg width="16" height="16" viewBox="0 0 24 24" className="-mr-0.5 transition-transform duration-300 group-hover:translate-x-1">
                <path d="M13 5l7 7-7 7M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* LOWER DARK FOOTER */}
      <section className="bg-[#1E2A44] py-12 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-10 md:gap-8">
          {/* Brand + about */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} alt="" />
              <span className="text-lg font-bold">Cabil</span>
            </div>
            <p className="text-sm text-slate-300 max-w-xs">
              AI-powered career mentorship platform connecting students and
              professionals with expert guidance.
            </p>
            <p className="text-xs text-slate-400 max-w-xs mt-3">
              A trading name of <span className="text-slate-300 font-semibold">Cabil Educational Services</span>
            </p>

            <div className="mt-5 space-y-1.5 text-xs text-slate-300 max-w-xs">
              <p>
                <a href="mailto:info@cabil.co" className="hover:text-white transition">info@cabil.co</a>
                {" · "}
                <a href="tel:+923314622245" className="hover:text-white transition">+92 331 4622245</a>
              </p>
              <p className="text-slate-400 leading-relaxed">
                Office 404, Al-Fiza Glass Tower, Block 10-A, Rashid Minhas Road, Karachi, Pakistan
              </p>
              <p className="text-slate-400 leading-relaxed">
                C-17, Sector 14-A, North Nazimabad Town, Karachi, Pakistan
              </p>
            </div>

            <div className="flex items-center gap-3 mt-5 text-white/70">
              <a href="https://www.facebook.com/share/1Ap7ra6r6r/" className="p-2.5 bg-white/10 rounded-full hover:bg-white/20 transition"><FaFacebookF size={14} /></a>

              <a href="https://www.linkedin.com/company/cabil/" className="p-2.5 bg-white/10 rounded-full hover:bg-white/20 transition"><FaLinkedinIn size={14} /></a>
              <a href="https://www.instagram.com/cabil_career_crew?igsh=MXJ6Ymw2bXpkMjg3cw==" className="p-2.5 bg-white/10 rounded-full hover:bg-white/20 transition"><FaInstagram size={14} /></a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li><a href="/kids" className="hover:text-white transition">Cabil Kids — Learning Games</a></li>
              <li><a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" onClick={() => track("play_store_click", { placement: "site_footer" })} className="hover:text-white transition">Cabil Kids on Google Play</a></li>
              <li><a href="/find-mentor" className="hover:text-white transition">Find Mentors</a></li>
              <li><a href="/ai-career" className="hover:text-white transition">AI Career Coach</a></li>
              <li><a href="/scholarship" className="hover:text-white transition">Scholarship Program</a></li>

            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li><a href="/about-us" className="hover:text-white transition">About Us</a></li>
              <li><a href="/career-guide" className="hover:text-white transition">Careers</a></li>
              <li><a href="/contact-us" className="hover:text-white transition">Contact</a></li>
              <li><a href="/blog" className="hover:text-white transition">Blog</a></li>
              <li><a href="/blog/how-to-use-cabil-kids-sign-up-and-play-guide" className="hover:text-white transition">How to Use Cabil Kids</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li><a href="/privacy-policy" className="hover:text-white transition">Privacy Policy</a></li>
              <li><a href="/terms-and-conditions" className="hover:text-white transition">Terms &amp; Conditions</a></li>
              <li><a href="/refund-policy" className="hover:text-white transition">Refund &amp; Cancellation Policy</a></li>
              <li><a href="/faq" className="hover:text-white transition">FAQ</a></li>
              <li><a href="/delete-account-request" className="hover:text-white transition">Delete Your Account</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-slate-700/60 pt-6 text-center text-sm text-slate-400">
          © 2026 Cabil Educational Services. All rights reserved.
        </div>
      </section>
    </footer>
  );
}
